import { Select, Spin } from "antd";
import { useState, useRef } from "react";
import toast from "react-hot-toast";
import { FiShoppingCart, FiTrash2 } from "react-icons/fi";
import { IoCloseSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Col, Modal, ModalBody, Row, Table } from "reactstrap";
import { getAllProducts } from "../../api/pagination";
import { uniqueID } from "../../firebase/utility";
import GeneralButton from "../button/GeneralButton";
import FormInput from "../formInput/FormInput";
const AddOrderItem = ({
  modal,
  toggle,
  setLineItems,
  line_items,
  setNewLineItems,
  soLineItems = [],
}) => {
  const { all_products } = useSelector((state) => state.products);
  const [selectedItemData, setSelectedItemData] = useState([]);
  const [searchProducts, setSearchProducts] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const debounceTimeout = useRef(null);

  const handleSearchProducts = async (searchText) => {
    setSearchQuery(searchText);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Clear stale results and skip API call for empty/whitespace search
    if (!searchText || searchText.trim().length === 0) {
      setSearchProducts([]);
      setDataLoading(false);
      return;
    }

    setDataLoading(true);

    debounceTimeout.current = setTimeout(() => {
      getAllProducts(1, searchText.trim(), 50, "", (res) => {
        setSearchProducts(res?.data?.data ?? []);
        setDataLoading(false);
      }, "exact");
    }, 500);
  };
  const handleSave = () => {
    const lineItems = [...line_items];

    let isErrorShown = false;
    let hasError = false;
    let arr = selectedItemData?.map((i) => {
      if (
        !i?.quantity ||
        isNaN(parseInt(i?.quantity)) ||
        parseInt(i?.quantity) <= 0
      ) {
        if (!isErrorShown) {
          toast.error("Please enter a valid quantity for all items.");
          isErrorShown = true;
        }
        hasError = true;
        return null;
      }
      if (soLineItems?.length > 0) {
        const soItem = soLineItems.find((soIt) =>
          (soIt.sku && i?.sku && soIt.sku.toLowerCase() === i.sku.toLowerCase())
        );
        if (soItem && parseInt(i?.quantity) > parseInt(soItem.quantity)) {
          if (!isErrorShown) {
            toast.error(
              `Quantity for SKU (${i?.sku}) cannot exceed Sales Order quantity (${soItem.quantity}).`
            );
            isErrorShown = true;
          }
          hasError = true;
          return null;
        }
      }
      if (i?.quickbooks_id && i?.quickbooks_id !== "") {
        const titleVal = i?.item_title || i?.name || i?.description || "";
        const newItem = {
          sku: i?.sku ?? "",
          quantity: parseInt(i?.quantity ?? 0),
          _id: uniqueID(),
          name: i?.name || i?.item_title || "",
          item_title: titleVal,
          description: titleVal,
          price: i?.price ?? "",
          dimensions: {
            ...(i?.dimensions && typeof i?.dimensions === 'object' && !Array.isArray(i?.dimensions) ? i.dimensions : {}),
            weight: i?.weight ?? 0,
          },
          image: { id: uniqueID(), src: i?.imageUrl ?? "" },
          quickbooks_id: i?.quickbooks_id ?? "",
        };
        return newItem;
      } else {
        if (!isErrorShown) {
          toast.error(`Selected Product (${i?.sku || 'Unknown'}) has no Quickbook ID, Please check`);
          isErrorShown = true;
        }
        hasError = true;
        return null;
      }
    });

    if (hasError) return;

    arr = arr?.filter((item) => item != null);

    const uniqueItems = arr.filter((newItem) => {
      const isDuplicate = lineItems.some(
        (existingItem) => existingItem.sku === newItem.sku
      );
      if (isDuplicate && !isErrorShown) {
        toast.error(`Item with SKU ${newItem.sku} is already added.`);
        isErrorShown = true;
      }
      return !isDuplicate;
    });
    if (uniqueItems.length === arr.length) {
      setLineItems([...lineItems, ...uniqueItems]);
      let new_items = [...uniqueItems];
      let allItems = [...lineItems, ...uniqueItems];
      if (allItems?.length > 0) {
        setNewLineItems(new_items);
        toggle();
      } else {
        return;
      }
    }
  };
  const onSelectOrder = (value, item) => {
    const selected_product =
      (searchQuery ? searchProducts : all_products)?.find((i) => i?._id === value);

    if (!selected_product) {
      toast.error("Selected product not found.");
      return;
    }
    if (selectedItemData?.find((i) => i?._id === selected_product?._id)) {
      toast.error("You cannot select duplicate orders.");
    } else {
      setSelectedItemData([...selectedItemData, selected_product]);
    }
  };
  const onPressRemoveItemFromList = (selectedItem) => {
    let selected_item = [...selectedItemData];
    let new_selected_item_list = selected_item?.filter(
      (i) => i?.id !== selectedItem?.id
    );
    setSelectedItemData(new_selected_item_list);
  };

  const isSaveDisabled =
    selectedItemData.length === 0 ||
    selectedItemData.some(
      (item) =>
        !item?.quantity ||
        isNaN(parseInt(item.quantity)) ||
        parseInt(item.quantity) <= 0
    );
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      centered
      size="lg"
      onClosed={() => {
        setSelectedItemData([]);
      }}
    >
      <ModalBody className="p-0 border-0">
        <div className="d-flex justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
          <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
            <FiShoppingCart className="text-primary" /> Add Order Items
          </h5>
          <IoCloseSharp size={24} className="text-muted pointer hover-opacity-75" onClick={toggle} style={{ cursor: "pointer" }} />
        </div>

        <div className="p-4">
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <label className="fw-bold small text-muted mb-2 text-uppercase">Search & Select Product</label>
              <span className="text-danger" style={{ fontSize: "12px" }}>
                * Search using part number only
              </span>
            </div>
            <Select
              size="large"
              showSearch
              loading={dataLoading}
              notFoundContent={dataLoading ? <Spin size="small" /> : "No products found"}
              placeholder="Start typing SKU or Name..."
              filterOption={false}
              onSelect={(value, option) => onSelectOrder(value)}
              onSearch={(val) => handleSearchProducts(val)}
              className="w-100"
              getPopupContainer={(trigger) => trigger.parentNode}
              options={(searchQuery ? searchProducts : all_products)?.map((item) => ({
                value: item._id,
                label: `${item.sku} - ${item.name || item.item_title || "Product"}`,
                item,
              }))}
            />
          </div>

          {selectedItemData?.length > 0 && (
            <>
              <div className="border rounded-3 overflow-hidden shadow-sm mb-4">
                <Table borderless hover responsive className="mb-0 align-middle">
                  <thead className="bg-light border-bottom">
                    <tr>
                      <th className="py-3 px-4 text-muted small fw-bold text-uppercase">SKU</th>
                      <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Item Title</th>
                      <th className="py-3 px-4 text-muted small fw-bold text-uppercase text-center" style={{ width: "120px" }}>Qty</th>
                      <th className="py-3 px-4 text-muted small fw-bold text-uppercase text-center" style={{ width: "80px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItemData?.map((i, index) => (
                      <tr key={index} className="border-bottom">
                        <td className="px-4 py-3 fw-bold text-dark">{i?.sku ?? ""}</td>
                        <td className="px-4 py-3 text-secondary" style={{ fontSize: "14px" }}>
                          {i?.item_title || i?.name || i?.description || ""}
                        </td>
                        <td className="px-4 py-3">
                          <FormInput
                            type="number"
                            required
                            min={1}
                            className="text-center rounded-2"
                            value={i?.quantity}
                            handleChange={(e) => {
                              let arr = [...selectedItemData];
                              arr[index].quantity = e.target.value;
                              setSelectedItemData(arr);
                            }}
                            style={{ height: "36px" }}
                          />
                        </td>
                        <td className="px-4 py-3 text-center">
                          <div
                            className="d-inline-flex p-2 rounded pointer text-danger border border-danger border-opacity-25"
                            style={{ backgroundColor: '#fff5f5' }}
                            onClick={() => onPressRemoveItemFromList(i)}
                            title="Remove Item"
                          >
                            <FiTrash2 size={16} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* Actions */}
              <div className="d-flex justify-content-end gap-2 pt-2 border-top mt-4 pt-4">
                <GeneralButton
                  title="Cancel"
                  className="bg-white border text-dark px-4 py-2 rounded-2"
                  handleClick={toggle}
                />
                <GeneralButton
                  title="Add Selected Items"
                  className="bg-primary text-white border-0 px-4 py-2 rounded-2"
                  handleClick={handleSave}
                  disabled={isSaveDisabled}
                />
              </div>
            </>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};
export default AddOrderItem;
